const URL = process.env.NODE_ENV === 'production' ? 'https://mfaapi.dafac.online/' : 'http://localhost:8650/'
// const URL = process.env.NODE_ENV === 'production' ? 'http://dfyf.nat300.top/' : 'http://localhost:5000/'
export default URL
